module.exports = __webpack_public_path__ + "static/media/background.1319f89a.svg";